import React from 'react'

const FolderIcon = ({ fill = '#1F1F1F', ...props }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M13.1193 2.06515H8.71929C8.56593 2.06529 8.41406 2.03507 8.27243 1.97623C8.13081 1.91738 8.00224 1.83108 7.89415 1.72229L7.04272 0.870865C6.82882 0.655817 6.57439 0.48534 6.29416 0.369303C6.01392 0.253266 5.71345 0.193975 5.41015 0.194865H2.88043C2.26824 0.195621 1.68134 0.439147 1.24846 0.872032C0.815572 1.30492 0.572045 1.89182 0.571289 2.50401V11.496C0.572045 12.1082 0.815572 12.6951 1.24846 13.128C1.68134 13.5609 2.26824 13.8044 2.88043 13.8052H13.1193C13.7315 13.8045 14.3185 13.5611 14.7514 13.1281C15.1843 12.6952 15.4278 12.1082 15.4284 11.496V4.37144C15.4272 3.75965 15.1835 3.17331 14.7506 2.74097C14.3177 2.30864 13.7311 2.0656 13.1193 2.06515Z'
        fill={fill}
      />
    </svg>
  )
}

export default FolderIcon
